import React from 'react';
import { connect } from "react-redux";
import { fetchMarketDetails, setCompareMarket, setComparisonMarketSelected } from '../../actions';
import '../../css/MarketCompare.scss';
import { withRouter } from 'react-router-dom';
import {appendParams} from '../../helpers/Utils';

 export class CompareMarketsList extends React.Component {
      hideAddCompareButton = (e) =>
      {
        this.props.hideAddCompareButton && this.props.hideAddCompareButton(e);
      }
      onClose = (e) => {
        this.props.onClose && this.props.onClose(e);
        };
      showRightPanel = (e) => {
          this.props.showRightPanel && this.props.showRightPanel(e);
          };
      OnMarketClick(market) 
      {

        const newUrl = appendParams(market,'comparemarket');

        this.props.history.push(`?${newUrl}`);
        this.hideAddCompareButton();
        this.props.getDetailCompare('FETCH_COMPARE_MARKET_DETAILS',market) // Commented this because we load again on componentDidMount of MarketDetailWheel
        this.onClose();
        this.showRightPanel();
        this.props.setCompareMarket(market);

      //  this.fetchMarketInfo(market)
      }

      fetchMarketInfo(market){
        market = market.trim()
        let region = ''
        let greaterRegion = ''
    
        this.props.markets.find((x) => {
          if (x.market === market){
            region = x.region 
            greaterRegion = x.greaterRegion    
          }
          return null;
        })

        this.props.setComparisonMarketSelected({greaterRegion, region, market});
      }

    render() {
      
        let market = null;
        if(this.props.comparegreaterregion ==="Global")
        {

          let displayOrder = ["Americas", "Europe", "Asia Pacific"];
           market = this.props.markets.reduce((marketsSoFar , { greaterRegion, market }) => {
            for (let i = 0; i < displayOrder.length; i++)
            {
               if (!marketsSoFar[displayOrder[i]]) marketsSoFar[displayOrder[i]] = [];
               if(displayOrder[i] === greaterRegion)
                    marketsSoFar[greaterRegion].push(market);
            }
            return marketsSoFar;
          }, {});
          
        }
        else{
         market = this.props.markets.reduce((marketsSoFar, { region, market }) => {
            if (!marketsSoFar[region]) marketsSoFar[region] = [];
            marketsSoFar[region].push(market);
            return marketsSoFar;
          }, {});
       
        }
 
        return (
              <div className = "compare-market-table-body" >
                  {
                    Object.keys(market).map((region,marketIndex) => (
                      <ul key={marketIndex}>
                              <li className ="market-region-heading">{region.replace('U.S.', 'United States').replace('CANADA', 'Canada').replace('LATIN AMERICA', 'Latin America')}</li>
                            {market[region].sort().map((mrkt,regionIndex) => (
                                <li className ="compare-market-name cursor-pointer" key={regionIndex} onClick ={()=>this.OnMarketClick(mrkt)}>{mrkt}</li>

                    ))}
                      </ul>

                      ))
                  }
              </div>    

        )
    }
}

const mapStateToProps = (state) => {
  
  return {
    comparegreaterregion: state.comparegreaterregion,
    leftpanelmarketselected: state.marketselected
  };
};

const mapDispatchToProps = (dispatch) => {
    return {
     getDetailCompare: (actionType,compareval) => {
      dispatch(fetchMarketDetails(actionType,compareval))
  },
      setCompareMarket : (market) =>
      {
        dispatch(setCompareMarket(market))
      },
        setComparisonMarketSelected: (selection) => {
         dispatch(setComparisonMarketSelected(selection))
        }
  }
}

export  default withRouter(connect(
  mapStateToProps,
    mapDispatchToProps
)(CompareMarketsList));
